import type { Copy } from "../types";

export const ta: Copy = {
    seo: {
      title: "கார் வயது கணிப்பான் | ஆண்டு மற்றும் மாதம் மூலம் வாகன வயதை சரிபார்க்கவும்",
      description:
        "உற்பத்தி ஆண்டு மற்றும் விருப்பமான மாதத்தின் அடிப்படையில் வாகனத்தின் துல்லியமான வயதை காணுங்கள். ஆண்டு, மாதம், நாள், மொத்த நாட்கள் மற்றும் முக்கிய கட்டங்களை ஒரே சுத்தமான கருவியில் பார்க்கலாம்.",
      keywords: [
        "கார் வயது கணிப்பான்",
        "வாகன வயது கணிப்பான்",
        "கார் உற்பத்தி ஆண்டு பார்க்க",
        "வாகன உற்பத்தி மாதம் பார்க்க",
        "என் கார் எத்தனை வயது",
        "ஆண்டு மூலம் கார் வயது",
        "வாகன வயதை சரிபார்க்க",
        "RC வயது கணிப்பான்",
        "மாதம் மூலம் கார் வயது",
        "வாகன தேதி கணிப்பான்",
        "mParivahan மாற்று",
        "Parivahan மாற்று",
        "RTO வாகன வயது கணிப்பான்",
        "கார் பதிவு வயது",
        "வாகன பதிவு வயது",
      ],
      faq: [
        {
          question: "இந்த கணிப்பான் என்ன செய்கிறது?",
          answer:
            "தேர்ந்தெடுத்த உற்பத்தி ஆண்டு மற்றும் விருப்ப மாதத்தின் அடிப்படையில் வாகனத்தின் துல்லியமான வயதை கணக்கிட்டு, ஆண்டு, மாதம், நாள் மற்றும் முக்கிய கட்டங்களை காட்டுகிறது.",
        },
        {
          question: "ஏன் விருப்ப மாதம் உள்ளது?",
          answer:
            "மாதத்தை சேர்ப்பதால் வயது கணக்கீடு மேலும் துல்லியமாகும். மாதம் தேர்வு செய்யாவிட்டால், தேர்ந்தெடுத்த ஆண்டின் ஜனவரி பயன்படுத்தப்படும்.",
        },
        {
          question: "எதிர்கால ஆண்டோ அல்லது மாதமோ தேர்வு செய்ய முடியுமா?",
          answer:
            "இல்லை. எதிர்கால ஆண்டுகள் தடுக்கப்பட்டுள்ளன, மேலும் தேர்ந்தெடுத்த ஆண்டு நடப்பு ஆண்டாக இருந்தால் எதிர்கால மாதங்களும் முடக்கப்படும்.",
        },
      ],
    },
    headerTagline: "வாகன பயன்பாடு",
    headerTitle: "கார் வயது கணிப்பான்",
    reset: "மீட்டமை",
    switchToLight: "ஒளி முறைக்கு மாற்று",
    switchToDark: "இருள் முறைக்கு மாற்று",
    languageLabel: "மொழி",
    languageEnglish: "ஆங்கிலம்",
    languageHindi: "இந்தி",
    heroEyebrow: "கார் வயது, தெளிவாக",
    heroTitle: "வாகன வயதை பார்க்க ஒரு சுத்தமான தேதி கருவி.",
    heroDescription: "உற்பத்தி ஆண்டை தேர்வு செய்யுங்கள். மேலும் துல்லியமான முடிவுக்கு மட்டுமே மாதத்தை சேர்க்கவும்.",
    yearSelectLabel: "உற்பத்தி ஆண்டு",
    monthSelectLabel: "உற்பத்தி மாதம்",
    includeMonthLabel: "மேலும் துல்லியத்திற்காக குறிப்பிட்ட மாதத்தை சேர்க்கவும்",
    includeMonthNote: "மாதம் சேர்க்காவிட்டால் கணக்கில் ஜனவரி பயன்படுத்தப்படும்.",
    yearOnlyBadge: "ஆண்டு மட்டும்",
    yearMonthBadge: "ஆண்டு + மாதம்",
    yearPlaceholder: "ஆண்டு தேர்வு",
    monthPlaceholder: "மாதம் தேர்வு",
    inputTitle: "உற்பத்தி ஆண்டு",
    inputLabel: "உற்பத்தி ஆண்டு",
    blockedDateNote: "எதிர்கால ஆண்டுகளை தேர்வு செய்ய முடியாது.",
    result: "முடிவு",
    vehicleAgeLead: "உங்கள் வாகனம்",
    asOfToday: "இன்றைய நிலவரப்படி",
    years: "ஆண்டு",
    months: "மாதங்கள்",
    days: "நாட்கள்",
    totalDays: (count) => `மொத்தம் ${count.toLocaleString("en-IN")} நாட்கள்`,
    ageLabels: { almostNew: "கிட்டத்தட்ட புதியது", modern: "நவீன", mature: "முதிர்ந்த", classic: "கிளாசிக்" },
    estimatedValue: {
      high: "மறுவிற்பனை வாய்ப்பு அதிகம்",
      healthy: "மதிப்பு நன்றாக தங்கும்",
      moderate: "மிதமான மதிப்பு குறைவு",
      collector: "சேகரிப்பாளர் ஆர்வம் அதிகரிக்கலாம்",
    },
    maintenanceTitle: "பராமரிப்பு",
    maintenance: {
      routine: "வழக்கமான சர்வீஸ் மற்றும் OEM பராமரிப்பு",
      watch: "பிரேக், திரவங்கள், டயர்களை கவனியுங்கள்",
      plan: "அணியும் பாகங்கள் மற்றும் ஆய்வுகளை திட்டமிடுங்கள்",
      specialized: "சிறப்பு பராமரிப்பு மேலும் முக்கியமாகிறது",
    },
    registrationTitle: "பதிவு",
    registration: {
      collector: "சில பகுதிகளில் சேகரிப்பாளர்-பாணி சலுகை கிடைக்கலாம்",
      classic: "சில பகுதிகளில் கிளாசிக் கார் பதிவு பொருந்தலாம்",
      standard: "சாதாரண புதுப்பித்தல் மற்றும் பிராந்திய சோதனைகளை எதிர்பார்க்கவும்",
      regular: "பொதுவாக வழக்கமான பதிவு பொருந்தும்",
    },
    upcomingMilestoneTitle: "அடுத்த முக்கிய கட்டம்",
    milestoneTimelineTitle: "முக்கிய கட்ட காலவரிசை",
    milestoneRemaining: ({ label, days }) => `${label} இன்னும் ${days.toLocaleString("ta-IN")} நாட்களில்`,
    reached: "எட்டப்பட்டது",
    upcoming: "வர உள்ளது",
    allMilestonesReachedTitle: "காட்டப்பட்ட அனைத்து முக்கிய கட்டங்களும் எட்டப்பட்டுவிட்டன",
    allMilestonesReachedBody: "இந்த வாகனம் பயன்பாட்டில் காட்டப்பட்ட முக்கிய கட்ட வரம்பை கடந்துவிட்டது.",
    copySummary: "சுருக்கத்தை நகலெடு",
    shareResult: "முடிவை பகிர்",
    resetMessage: "கணிப்பான் மீட்டமைக்கப்பட்டது",
    summaryCopied: "சுருக்கம் கிளிப்போர்டுக்கு நகலெடுக்கப்பட்டது",
    clipboardFailed: "கிளிப்போர்டை அணுக முடியவில்லை",
    emptyTitle: "முழு விவரத்தை காண உற்பத்தி ஆண்டை தேர்ந்தெடுக்கவும்",
    emptyDescription:
      "ஆண்டு தேர்ந்தெடுத்ததும், துல்லியமான வயது, மொத்த நாட்கள், பராமரிப்பு குறிப்புகள், கிளாசிக் நிலை மற்றும் முக்கிய கட்ட நேரம் காட்டப்படும்.",
    shareTitle: "கார் வயது கணிப்பான்",
    summary: ({ label, years, months, days, asOf }) =>
      `என் கார் ${label} இல் தயாரிக்கப்பட்டது, ${asOf} நிலவரப்படி அதன் வயது ${years} ஆண்டு ${months} மாதம் ${days} நாட்கள்.`,
    milestones: {
      1: { label: "முதல் ஆண்டு", note: "உத்தரவாதம் மற்றும் சேவை திட்டமிடலுக்கு பயனுள்ளது." },
      3: { label: "மூன்று ஆண்டு", note: "மறுவிற்பனை மற்றும் மதிப்பு மாற்றத்திற்கான பொதுவான காலம்." },
      5: { label: "ஐந்து ஆண்டு", note: "பராமரிப்பு பட்ஜெட்டை மறுபரிசீலனை செய்ய நல்ல நேரம்." },
      10: { label: "பத்து ஆண்டு", note: "வயதான பாகங்களுக்கு கூடுதல் கவனம் தேவை." },
      15: { label: "பதினைந்து ஆண்டு", note: "பல பகுதிகளில் கிளாசிக் பாணி நடைமுறை தொடங்கும்." },
      25: { label: "இருபத்து ஐந்து ஆண்டு", note: "சில சந்தைகளில் சேகரிப்பாளர் மற்றும் இறக்குமதிக்குப் பொருந்தலாம்." },
    },
  };
